import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { APP_CONFIG } from 'src/app/app.const';
import { AppService } from 'src/app/shared/services/app.service';

@Component({
  selector: 'app-first-block',
  templateUrl: './first-block.component.html',
  styleUrls: ['./first-block.component.scss']
})
export class FirstBlockComponent implements OnInit {

  @Input() isMobile = false;
  @Input() isVip = false
  firebaseBaseUrl = `${APP_CONFIG.FIREBASE.BASE_URL}qatch-home%2Ffirst-block.jpeg?alt=media`;
  
  constructor(
    private appService: AppService
  ) { }

  ngOnInit(): void {
  }

  onSignup() {
    this.appService.navigate( 'signup', this.isVip ? {queryParams: {is_premium:true}, queryParamsHandling: "merge"} :  {queryParamsHandling: "merge"});
  }

}
